import React from "react";
import { DEFAULT_CLPT_SKILL_MODULES } from "utils/helperConstants";

export const getTestTypeBadgeClassName = (testType) => {
  let badgeClassName;
  switch (testType) {
    case "aptitude":
      badgeClassName = "aptitude-test-type-badge";
      break;
    case "personality":
      badgeClassName = "personality-test-type-badge";
      break;
    case "emotional":
      badgeClassName = "emotional-test-type-badge";
      break;
    case "skills":
      badgeClassName = "skills-test-type-badge";
      break;
    case "risk":
      badgeClassName = "risk-test-type-badge";
      break;
    default:
      badgeClassName = "testmaker-test-type-badge";
      break;
  }
  return badgeClassName;
};

export const testDescriptionsByTestId = {
  10: {
    measures:
      "Critical thinking, Problem solving skills, Learning ability, Aptitude for applying new information",
    benefits: "Reduce onboarding costs, Increase productivity, Reduce turnover",
    candidateAttributes:
      "Find candidates who can learn, adapt, and apply new information and communicate effectively.",
  },
  29: {
    measures:
      "A blend of twelve personality traits that are predictive of a person’s work style",
    benefits: "Improve retention, More cohesive company culture",
    candidateAttributes:
      "Find candidates who are more likely to be comfortable in this job role and stay with your company longer.",
  },
  34: {
    measures:
      "A blend of twelve personality traits that are predictive of a person’s work style",
    benefits: "Improve retention, More cohesive company culture",
    candidateAttributes:
      "Find candidates who are more likely to be comfortable in this job role and stay with your company longer.",
  },
  12: {
    measures:
      "Job readiness, Trainability, Learning ability, Attention to detail",
    benefits: "Reduce turnover, Reduce mistakes",
    candidateAttributes:
      "Find candidates who can complete detailed work with accuracy, communicate clearly, and represent you well.",
  },
  15: {
    measures:
      "Cooperativeness, Personal Diplomacy, Patience, Relaxed Attitude, Achievement",
    benefits: "Increase productivity, Reduce turnover, Reduce hiring costs",
    candidateAttributes:
      "Find candidates who are comfortable in a customer service role.",
  },
  24: {
    measures:
      "Achievement, Cold Calling Initiative, Competitiveness, Sales Closing, Sales Disposition",
    benefits: "Increase productivity, Reduce turnover, Reduce hiring costs",
    candidateAttributes:
      "Find candidates who are comfortable prospecting leads, cold-calling, and closing sales.",
  },
  30: {
    measures:
      "Using internet browsers, Email applications, Word processing programs",
    benefits: "Increase productivity",
    candidateAttributes:
      "Find candidates with the basic computer skills needed to perform most office functions and the ability to learn internal programs.",
  },
  23: {
    measures:
      "Mental fitness, Concentration, Ability to sustain focus and avoid distractions",
    benefits: "Reduce accidents",
    candidateAttributes: null,
  },
  16: {
    measures:
      "Measures the ability to learn how to operate, maintain, install, and repair equipment and machinery",
    benefits: "Increase productivity, Reduce accidents",
    candidateAttributes:
      "Find candidates who can learn to operate, repair, and install machinery, and adapt as processes and equipment change.",
  },
  31: {
    measures: "Conscientiousness, Productivity, Reliability, Rule-adherence",
    benefits: "Reduce tardiness, Reduce absenteeism, Reduce accidents",
    candidateAttributes:
      "Find candidates who will show up on time, work hard, and follow rules.",
  },
  17: {
    measures: "Typing speed and accuracy",
    benefits: null,
    candidateAttributes: null,
  },
  37: {
    measures:
      "Critical thinking, Problem solving ability, Attention to detail, Logic and analysis",
    benefits: null,
    candidateAttributes: null,
  },
  14: {
    measures:
      "Mental fitness, Attention and focus, Working memory, Reasoning ability",
    benefits: null,
    candidateAttributes: null,
  },
  13: {
    measures:
      "Agreeableness, Conscientiousness, Extraversion, Openness, Stress Tolerance",
    benefits: null,
    candidateAttributes: null,
  },
  18: {
    measures: "Ability to perform data entry for numerical fields",
    benefits: null,
    candidateAttributes: null,
  },
  38: {
    measures:
      "Ability to successfully complete basic tasks within PowerPoint that are necessary to a wide range of positions",
    benefits: null,
    candidateAttributes: null,
  },
  41: {
    measures:
      "Ability to successfully complete basic tasks within PowerPoint that are necessary to a wide range of positions",
    benefits: null,
    candidateAttributes: null,
  },
  20: {
    measures:
      "Ability to successfully complete basic tasks within Word across a wide range of positions requiring regular computer use",
    benefits: null,
    candidateAttributes: null,
  },
  22: {
    measures:
      "Ability to successfully complete basic tasks within Word across a wide range of positions requiring regular computer use",
    benefits: null,
    candidateAttributes: null,
  },
  33: {
    measures:
      "Ability to successfully complete basic tasks within Word across a wide range of positions requiring regular computer use",
    benefits: null,
    candidateAttributes: null,
  },
  36: {
    measures:
      "Ability to successfully complete basic tasks within Word across a wide range of positions requiring regular computer use",
    benefits: null,
    candidateAttributes: null,
  },
  40: {
    measures:
      "Ability to successfully complete basic tasks within Word across a wide range of positions requiring regular computer use",
    benefits: null,
    candidateAttributes: null,
  },
  19: {
    measures:
      "Ability to successfully complete basic tasks within Excel across a wide range of positions requiring regular computer use and data entry",
    benefits: null,
    candidateAttributes: null,
  },
  21: {
    measures:
      "Ability to successfully complete basic tasks within Excel across a wide range of positions requiring regular computer use and data entry",
    benefits: null,
    candidateAttributes: null,
  },
  32: {
    measures:
      "Ability to successfully complete basic tasks within Excel across a wide range of positions requiring regular computer use and data entry",
    benefits: null,
    candidateAttributes: null,
  },
  35: {
    measures:
      "Ability to successfully complete basic tasks within Excel across a wide range of positions requiring regular computer use and data entry",
    benefits: null,
    candidateAttributes: null,
  },
  39: {
    measures:
      "Ability to successfully complete basic tasks within Excel across a wide range of positions requiring regular computer use and data entry",
    benefits: null,
    candidateAttributes: null,
  },
  42: {
    measures:
      "Critical thinking, Problem solving skills, Learning ability, Attention to detail",
    benefits:
      "Increase productivity, Reduce turnover, Improve training outcomes",
    candidateAttributes:
      "Find candidates who can learn, adapt, and apply new information.",
  },
  43: {
    measures:
      "Measures the ability to learn how to operate, maintain, install, and repair equipment and machinery.",
    benefits: "Increase productivity, Reduce onboarding / training time",
    candidateAttributes:
      "Find candidates who can learn to operate, repair, and install machinery, and adapt as processes and equipment change.",
  },
  44: {
    measures:
      "Find candidates who can accurately identify emotions and who can effectively understand how different situations can impact emotions",
    benefits:
      "Build better team relationships, Improve communications, Identify effective leaders",
    candidateAttributes: "Perceiving emotions, Understanding emotions",
  },
  45: {
    measures:
      "Assess attributes critical to every role: problem solving, numerical reasoning and verbal knowledge",
    benefits:
      "Results from Cognify allow you to predict how candidates will perform on the job",
    candidateAttributes:
      "Find candidates who can learn, adapt, and apply new information and communicate effectively.",
  },
  46: {
    measures:
      "Safety control, risk aversion, stress management, drug aversion, attitudes towards violence",
    benefits:
      "Reduce accidents, injuries and support a positive safety culture",
    candidateAttributes:
      "Find candidates who will follow safety rules, support safe work practices, and avoid accidents and injuries at work.",
  },
  47: {
    measures:
      "Critical thinking, Problem solving skills, Learning ability, Aptitude for applying new information",
    benefits: "Reduce onboarding costs, Increase productivity, Reduce turnover",
    candidateAttributes:
      "Find candidates who can learn, adapt, and apply new information and communicate effectively.",
  },
  48: {
    measures:
      "Competencies that have been selected because of their importance to a specific job. The Work Styles option includes an additional report with eight traits that can give you insight into a candidate’s general work style.",
    benefits:
      "Results from Illustrait allow you to find candidates that are likely to perform well in a particular job and fit in with your team",
    candidateAttributes:
      "Find candidates who have the attributes needed to be comfortable and perform well in a job, and stay longer.",
  },
  49: {
    measures:
      "Using internet browsers, Email & Calendar applications, Word processing programs and Chat applications",
    benefits: "Increase productivity",
    candidateAttributes:
      "Find candidates with the basic computer skills needed to perform most office functions and the ability to learn internal programs.",
  },
  50: {
    measures:
      "Alignment between what's important to candidates in their ideal job and what's provided by the organization",
    benefits:
      "Increased employee commitment and satisfaction, reduced turnover",
    candidateAttributes: null,
  },
  51: {
    measures:
      "The ability to identify emotions in others, understand how different situations can impact emotions, and manage a variety of emotions in the workplace",
    benefits:
      "Build stronger teams, improve communication, identify effective leaders",
    candidateAttributes:
      "Find candidates who can perceive, understand and manage emotions effectively.",
  },
  52: {
    measures:
      "Assess attributes critical to many roles: problem solving and numerical reasoning",
    benefits:
      "Results from UCognify allow you to predict how candidates will perform on the job",
    candidateAttributes:
      "Find candidates who can learn, adapt, and apply new information effectively.",
  },
  53: {
    measures:
      "Ability to complete a wide range of functionalities in Excel 365 for positions requiring regular use of this software. Includes a mixture of interactive simulations and multiple choice questions.",
    benefits: null,
    candidateAttributes: null,
  },
  54: {
    measures:
      "Ability to complete a wide range of functionalities in Word 365 for positions requiring regular use of this software",
    benefits: null,
    candidateAttributes: null,
  },
  55: {
    measures:
      "Ability to complete a wide range of functionalities in PowerPoint 365 for positions requiring regular use of this software.",
    benefits: null,
    candidateAttributes: null,
  },
  57: {
    measures:
      "Proficiency in the English language across one or more of the following skills: reading, listening, and writing.",
    benefits: "Communication",
    candidateAttributes:
      "Find candidates with communication skills in the English language.",
  },
  59: {
    measures:
      "Critical thinking, Problem-solving skills, Learning ability, Aptitude for applying new information",
    benefits: "Reduce onboarding costs, Increase productivity, Reduce turnover",
    candidateAttributes:
      "Find candidates who can learn, adapt, and apply new information and communicate effectively.",
  },
  // LAST LINE - DO NOT MOVE THIS COMMENT testDescriptionsByTestId
};

export const testDescriptionsBySubTestId = {
  120: {
    measures: "Safety control, risk aversion, stress management",
    benefits: null,
    candidateAttributes: null,
  },
  180: {
    measures:
      "Ability to complete a wide range of functionalities in Excel 365 for positions requiring regular use of this software",
    benefits: null,
    candidateAttributes: null,
  },
  190: {
    measures:
      "Proficiency in the English language across one or more of the following skills: reading, listening, and writing.",
  },
  191: {
    measures:
      "Proficiency in the English language across the skills of reading, listening, and writing.",
  },
};

// TODO: fix default param last
export const showScoreRangeBox = (
  scoreRangeDropdowns,
  testId,
  testBaselineName = null, // eslint-disable-line default-param-last
  editScoreRanges,
  fromAutomation = null, // eslint-disable-line default-param-last
  fromCustom = null, // eslint-disable-line default-param-last
  fromSettings = null, // eslint-disable-line default-param-last
  testBaselineId
) => {
  // here we determine if there is an existing score range for the test, either a custom or a Criteria recommended
  // one.  If so, we want to display the score range box in the TestBox component.

  // this is an array of all possible testIds that have score ranges of some type
  const [...keys] = scoreRangeDropdowns.keys();

  // if score ranges can be edited, and at least one score range exists for that test
  if (editScoreRanges && keys.includes(String(testId).toLowerCase())) {
    return true;
  }

  // if score ranges are not being edited, and if being view in JobSettings and no score ranges are
  // currently assigned
  if (fromSettings && !testBaselineId) {
    return false;
  }

  // if the test box has a testBaselineName (meaning there is a Criteria recommended score range for that test), we
  // want to display it.
  if (testBaselineName) {
    return true;
  }

  // otherwise, if the test has a possible score range, then we want to display the box so that a score range can
  // be selected.
  if (
    keys.includes(String(testId).toLowerCase()) &&
    (editScoreRanges || fromAutomation || fromCustom)
  ) {
    return true;
  }

  // otherwise, do not score the score range box
  return false;
};

export const determineTestBaselineIdToReplace = (
  testBaselineIds,
  scoreRanges
) => {
  // to determine which testBaselineId to replace, we want to loop through the list of current testBaselineIds
  // and then iterate through the score range for each testId to determine if that testBaselineId is in that
  // score range.  If it is in the scoreRange list, then that means that is the id we want to replace.  Otherwise,
  // it doesn't exist in the range and it is not the one we want to replace.
  let idToReplace = null;
  if (testBaselineIds) {
    testBaselineIds.map((id) => {
      const currentId = id;
      const [...keys] = scoreRanges ? scoreRanges.keys() : [];
      if (keys.includes(String(currentId))) {
        idToReplace = id;
      }
    });
  }
  return idToReplace;
};

export const getHeaderText = (
  showPopularJobs,
  incompleteMatch,
  isAU,
  isFreeTrial // New Job Creation logic is only for non free trial users
) => {
  // TODO: Will revert changes back to not have localized text in localization phase 2
  // TODO: remove New Job Creation once applied to all users

  if (
    (!showPopularJobs && !incompleteMatch && !isAU) ||
    (!showPopularJobs && !incompleteMatch && isAU && !isFreeTrial)
  ) {
    return (
      <p className="lead">
        Below are the <strong>Criteria Recommended Test Batteries</strong> for
        your job title. We recommend tests based on the knowledge, skills, and
        abilities required for a specific job so that you can find the best
        candidates.
      </p>
    );
  }
  if (
    (!showPopularJobs && incompleteMatch && !isAU) ||
    (!showPopularJobs && incompleteMatch && isAU && !isFreeTrial)
  ) {
    return (
      <p className="lead">
        {`We didn’t find an exact match, but here are test batteries recommended
        for related positions.`}
      </p>
    );
  }
  if ((showPopularJobs && !isAU) || (showPopularJobs && isAU && !isFreeTrial)) {
    return (
      <p className="lead">
        {`We didn't find an exact match. Try searching for a similar job title or select from our most commonly tested jobs.`}
      </p>
    );
  }
  // New Job Creation logic is only for non free trial users
  if (isAU && isFreeTrial) {
    return (
      <p className="lead">
        You can either create your own test battery or select one of the
        batteries listed below.
      </p>
    );
  }
  return false;
};

export const getIllustraitConfigurationMap = (customBatteries) => {
  const illustraitConfigurationMap = {};
  customBatteries.valueSeq().forEach((battery) => {
    if (battery.get("subTests")) {
      battery
        .get("subTests")
        .keySeq()
        .forEach((testId) => {
          if (testId === "48") {
            illustraitConfigurationMap[battery.get("testBatteryId")] = {
              workStylesOn: true,
              selectedCompetencySet: null,
            };
          }
        });
    }
  });
  return illustraitConfigurationMap;
};

export const getClptSkillModulesMap = (customBatteries) => {
  const clptSkillModulesMap = {};
  customBatteries.forEach((battery) => {
    if (battery.get("subTests") && battery.get("subTests").has("57")) {
      clptSkillModulesMap[battery.get("testBatteryId")] =
        DEFAULT_CLPT_SKILL_MODULES;
    }
  });
  return clptSkillModulesMap;
};

export const removePunctuation = (searchTerm) =>
  searchTerm
    .replace(/[.,/#!$%^&*;:@{}=\\\-_`~()0-9]/g, "")
    .replace(/\s{2,}/g, " ");

export const getStagePipelineIdByOrder = (hiringPipelineId, pipelines, order) =>
  pipelines &&
  pipelines.get(String(hiringPipelineId)) &&
  pipelines.get(String(hiringPipelineId)).get("stages") &&
  pipelines
    .get(String(hiringPipelineId))
    .get("stages")
    .get("data")
    .find((stage) => stage.get("stageOrder") === Number(order))
    .get("pipelineStageMapId");

export const getNextConfigUrl = (addVideoInterview, addLiveInterview) => {
  if (addVideoInterview) {
    return `/createJob_videoInterview`;
  }
  if (addLiveInterview) {
    return `/createJob_liveInterview`;
  }
  return "/createJob";
};

export const navigateToMultipleLanguages = (isAU) => {
  const url = isAU
    ? "https://criteriacorp.helpdocs.io/article/aph8go94x5-candidate-assessment-languages"
    : "https://criteria.helpdocs.io/article/jab1q1pinj-test-languages-for-candidates";

  window.open(url);
};
